export default __webpack_public_path__ + "static/michigan-1-c62b56d8ae4faf47ad1edd477030c738.jpg";